import type { Translation } from '../../types';
import type { market as en } from '../en/market';

export const market: Translation<typeof en> = {
  area: 'Kinh doanh',
  any: 'Tất cả',
  none: 'không có',
  refresh: 'Làm mới',
  resetFilters: 'Xoá bộ lọc',
  back: 'Quay lại',
  reasonRequired: 'Lý do (bắt buộc)',
  enum: {
    auctionStatus: {
      SCHEDULED: 'Đã lên lịch',
      OPEN: 'Đang diễn ra',
      CLOSED: 'Đã đóng, chờ quyết toán',
      SETTLING: 'Đang quyết toán',
      SETTLED: 'Đã quyết toán',
      UNSOLD: 'Không bán được',
      FAILED: 'Thất bại',
      CANCELLED: 'Đã huỷ',
    },
    auctionKind: { PUBLIC: 'Công khai', BACKORDER_PRIVATE: 'Đặt giữ tên miền (riêng)' },
    backorderStatus: {
      ACTIVE: 'Đang hiệu lực',
      ASSIGNED: 'Đã chỉ định',
      IN_AUCTION: 'Đang đấu giá',
      WON: 'Thắng',
      LOST: 'Thua',
      REGISTERING: 'Đang đăng ký',
      CAUGHT: 'Đã bắt được',
      NOT_CAUGHT: 'Không bắt được',
      CANCELLED: 'Đã huỷ',
    },
    dropStatus: {
      SCHEDULED: 'Đã lên lịch',
      AUCTION: 'Đang đấu giá',
      ASSIGNED: 'Đã chỉ định',
      CAUGHT: 'Đã bắt được',
      NOT_CAUGHT: 'Không bắt được',
      NO_DEMAND: 'Không có nhu cầu',
      CANCELLED: 'Đã huỷ',
    },
    catchStatus: {
      PLANNED: 'Đã lên kế hoạch',
      POLLING: 'Đang dò',
      REGISTERING: 'Đang đăng ký',
      CAUGHT: 'Đã bắt được',
      NOT_CAUGHT: 'Không bắt được',
      MANUAL_REVIEW: 'Cần xem xét thủ công',
    },
    rejectReason: {
      AUCTION_NOT_OPEN: 'Phiên chưa mở',
      AUCTION_ENDED: 'Phiên đã kết thúc',
      BELOW_MINIMUM: 'Thấp hơn mức tối thiểu',
      CURRENCY_MISMATCH: 'Sai loại tiền tệ',
      NOT_ELIGIBLE: 'Không đủ điều kiện',
      INSUFFICIENT_FUNDS: 'Không đủ số dư',
    },
    dropSource: { OPERATOR: 'Nhân viên vận hành', REGISTRY_NOTICE: 'Thông báo của registry', LIFECYCLE: 'Vòng đời tên miền' },
    checkResult: { AVAILABLE: 'Tên miền đã trống', UNAVAILABLE: 'Tên miền vẫn chưa trống' },
    level: { STANDARD: 'Tiêu chuẩn', PRIORITY: 'Ưu tiên' },
    auctionEvent: {
      AUCTION_CREATED: 'Tạo phiên đấu giá',
      AUCTION_OPENED: 'Mở nhận trả giá',
      BID_ACCEPTED: 'Chấp nhận lượt trả giá',
      BID_REJECTED: 'Từ chối lượt trả giá',
      BIDDER_OUTBID: 'Có người trả giá cao hơn',
      AUCTION_EXTENDED: 'Gia hạn thời điểm kết thúc',
      AUCTION_CLOSED: 'Đóng nhận trả giá',
      WINNER_SELECTED: 'Chọn người thắng',
      AUCTION_UNSOLD: 'Kết thúc, không bán được',
      SETTLEMENT_STARTED: 'Bắt đầu quyết toán',
      PAYMENT_SETTLED: 'Đã quyết toán thanh toán',
      DOMAIN_ASSIGNED: 'Đã bàn giao tên miền',
      SETTLEMENT_FAILED: 'Quyết toán thất bại',
      BACKORDER_ASSIGNED: 'Đã gán yêu cầu đặt giữ',
      RESULT_OVERRIDDEN: 'Đã can thiệp kết quả',
      AUCTION_CANCELLED: 'Đã huỷ phiên đấu giá',
    },
    backorderEvent: {
      BACKORDER_PLACED: 'Đã đặt giữ tên miền',
      BACKORDER_CANCELLED: 'Đã huỷ đặt giữ tên miền',
      BACKORDER_ASSIGNED: 'Được gán cho tên miền rơi',
      BACKORDER_IN_AUCTION: 'Chuyển sang đấu giá',
      BACKORDER_RETURNED: 'Trả lại hàng chờ',
      BACKORDER_WON: 'Thắng phiên đấu giá',
      BACKORDER_LOST: 'Thua phiên đấu giá',
      BACKORDER_REGISTERING: 'Đang đăng ký tên miền',
      BACKORDER_CAUGHT: 'Đã bắt được tên miền',
      BACKORDER_NOT_CAUGHT: 'Không bắt được tên miền',
    },
    holdStatus: { ACTIVE: 'Đang tạm giữ', RELEASED: 'Đã giải phóng', CAPTURED: 'Đã thu', EXPIRED: 'Đã hết hạn' },
    holdPurpose: {
      REGISTRATION: 'Đăng ký',
      RENEWAL: 'Gia hạn',
      TRANSFER: 'Chuyển nhà đăng ký',
      RESTORE: 'Phục hồi',
      AUCTION: 'Đấu giá',
      DROPCATCH: 'Bắt tên miền rơi',
      OTHER: 'Khác',
    },
    actorType: { OPERATOR: 'nhân viên vận hành', CUSTOMER: 'khách hàng', RESELLER: 'đại lý', SYSTEM: 'hệ thống', EXTERNAL: 'bên ngoài' },
  },
  format: {
    official: 'Chính thức',
    draft: 'Bản nháp không chính thức',
    draftTitle: 'Định dạng nội bộ UNOFFICIAL_DRAFT: chưa có đặc tả Registrar Data Escrow chính thức (ARCHITECTURE §14)',
    noticeTitle: 'Định dạng nháp không chính thức.',
    notice:
      'Chưa có đặc tả ICANN Registrar Data Escrow chính thức (cấu trúc tệp, ánh xạ trường, tham số mã hoá và truyền tải) (ARCHITECTURE §14). Các bản ký quỹ được tạo theo định dạng nội bộ {{format}} và không phải là bản ký quỹ ICANN RDE.',
  },
  countdown: {
    endsIn: 'Kết thúc sau',
    startsIn: 'Bắt đầu sau',
    ended: 'Đã kết thúc',
    days: '{{count}} ngày',
    closingSoon: 'Sắp kết thúc',
  },
  auctions: {
    title: 'Đấu giá',
    subtitle: 'Các tên miền đang được đấu giá, kèm mức giá hiện tại, người trả giá và kết quả.',
    loadError: 'Không tải được danh sách đấu giá',
    empty: 'Không có phiên đấu giá phù hợp',
    list: 'Phiên đấu giá',
    listDesc: 'Thời điểm kết thúc muộn nhất trước',
    kind: 'Hình thức',
    status: 'Trạng thái',
    domain: 'Tên miền',
    domainPlaceholder: 'tên chính xác',
    live: 'Đang diễn ra',
    liveHint: 'Đang nhận trả giá',
    closingSoon: 'Kết thúc trong {{hours}} giờ',
    closingSoonHint: 'Phiên đang diễn ra sắp kết thúc',
    awaiting: 'Đã đóng, chưa quyết toán',
    awaitingHint: 'Chờ quyết toán cho người thắng hoặc can thiệp kết quả',
    scheduled: 'Đã lên lịch',
    scheduledHint: 'Chưa mở',
    showThese: 'Xem các phiên này',
    price: 'Giá hiện tại / cuối cùng',
    reserve: 'Giá sàn',
    reserveMet: 'đạt',
    bidCount_one: '{{count}} lượt trả giá',
    bidCount_other: '{{count}} lượt trả giá',
    ends: 'Kết thúc',
    extended: 'gia hạn ×{{count}}',
    open: 'Mở phiên đấu giá {{domain}}',
    leader: 'Người dẫn đầu / người thắng',
    noBidder: 'Chưa có lượt trả giá',
  },
  auction: {
    liveOn: 'Trực tiếp',
    liveReconnecting: 'Đang kết nối lại…',
    title: 'Phiên đấu giá',
    docTitle: 'Đấu giá {{domain}}',
    loadError: 'Không tải được phiên đấu giá',
    public: 'Đấu giá công khai',
    private: 'Đấu giá riêng giữa các yêu cầu đặt giữ',
    cancel: 'Huỷ phiên đấu giá…',
    override: 'Can thiệp kết quả…',
    terms: 'Điều khoản',
    startPrice: 'Giá khởi điểm',
    reserve: 'Giá sàn',
    starts: 'Bắt đầu',
    ends: 'Kết thúc',
    originalEnd: 'Kết thúc ban đầu',
    extensions: 'Số lần gia hạn',
    drop: 'Tên miền rơi',
    policyHash: 'Mã băm chính sách',
    createdBy: 'Người tạo',
    result: 'Kết quả',
    currentPrice: 'Giá hiện tại',
    bidsAccepted: 'Lượt trả giá được chấp nhận',
    leader: 'Người đang dẫn đầu',
    highest: 'Lượt trả giá cao nhất',
    winner: 'Người thắng',
    finalPrice: 'Giá cuối cùng',
    winningBid: 'Lượt thắng',
    closed: 'Đóng lúc',
    settled: 'Quyết toán lúc',
    order: 'Đơn hàng',
    openOrder: 'Mở đơn hàng',
    domain: 'Tên miền',
    openBackorder: 'Mở yêu cầu đặt giữ',
    overrideApproval: 'Phê duyệt can thiệp',
    statusReason: 'Lý do trạng thái',
    noWinner: 'Chưa có người thắng',
    reserveMet: 'Đạt giá sàn',
    reserveNotMet: 'Chưa đạt giá sàn',
    noReserve: 'Không có giá sàn',
    bidsTitle: 'Lịch sử trả giá',
    bidsDesc: 'Lượt trả giá được chấp nhận và bị từ chối, theo thứ tự quyết định. Lượt trả giá đã được chấp nhận là quyết định cuối cùng và số tiền là chính xác.',
    bidsTruncated:
      '{{shown}} lượt trả giá gần nhất trong tổng số {{count}}. Lượt trả giá đã được chấp nhận là quyết định cuối cùng và số tiền là chính xác.',
    noBids: 'Chưa có lượt trả giá',
    seq: 'STT',
    bidder: 'Người trả giá',
    amount: 'Số tiền',
    minimum: 'Tối thiểu',
    outcome: 'Kết quả',
    decided: 'Quyết định lúc',
    received: 'nhận lúc {{at}}',
    clientBidId: 'Mã lượt trả giá (client)',
    bidWinner: 'Người thắng',
    bidLeading: 'Dẫn đầu',
    bidHighest: 'Cao nhất',
    bidAccepted: 'Chấp nhận',
    bidRejected: 'Từ chối',
    participants: 'Người tham gia',
    openToAll: 'Mở cho mọi khách hàng đủ điều kiện',
    customer: 'Khách hàng',
    registrant: 'Chủ thể đăng ký',
    backorder: 'Đặt giữ tên miền',
    joined: 'Tham gia lúc',
    history: 'Lịch sử',
    historyDesc: '{{count}} sự kiện, thứ tự liên tục không đứt quãng',
    historyTruncated: '{{shown}} sự kiện gần nhất trong tổng số {{count}}',
    correlation: 'Correlation',
  },
  cancel: {
    title: 'Huỷ phiên đấu giá',
    description: 'Chỉ thực hiện được trước khi bắt đầu quyết toán. Các khoản tạm giữ được giải phóng; việc huỷ được ghi audit và lưu vào lịch sử phiên đấu giá.',
    submit: 'Huỷ phiên đấu giá',
    busy: 'Đang huỷ…',
  },
  override: {
    title: 'Can thiệp kết quả (bốn mắt)',
    description:
      'Can thiệp kết quả cần hai nhân viên. Bạn gửi yêu cầu phê duyệt, một nhân viên khác phê duyệt hoặc từ chối, sau đó thực hiện can thiệp bằng mã yêu cầu đã được phê duyệt. Mọi bước đều được ghi audit.',
    step1: 'Gửi yêu cầu phê duyệt',
    step1Body: 'Người phê duyệt thấy chính xác tác động của việc can thiệp.',
    what: 'Hình thức can thiệp',
    void: 'Huỷ kết quả (không bán, giải phóng mọi khoản tạm giữ)',
    award: 'Trao cho một lượt trả giá khác đã được chấp nhận',
    bid: 'Lượt trả giá',
    request: 'Gửi yêu cầu phê duyệt',
    requesting: 'Đang gửi…',
    requested: 'Đã gửi yêu cầu phê duyệt:',
    requestedNext: 'Một nhân viên khác phải phê duyệt.',
    step2: 'Nhân viên thứ hai quyết định',
    step2Body: 'Bạn không thể tự phê duyệt yêu cầu của chính mình.',
    noPending: 'Không có yêu cầu phê duyệt nào đang chờ cho phiên đấu giá này.',
    requestedBy: 'yêu cầu bởi',
    decisionReason: 'Lý do quyết định (bắt buộc)',
    approve: 'Phê duyệt',
    reject: 'Từ chối',
    step3: 'Thực hiện bằng mã yêu cầu đã được phê duyệt',
    step3Body: 'Tự động điền khi một yêu cầu được phê duyệt tại đây.',
    approvalId: 'Mã yêu cầu đã phê duyệt (bắt buộc)',
    executeReason: 'Lý do (bắt buộc, ghi audit)',
    execute: 'Thực hiện can thiệp',
    executing: 'Đang thực hiện…',
  },
  backorders: {
    title: 'Đặt giữ tên miền',
    subtitle: 'Đặt giữ tên miền (backorder): khách hàng đang chờ một tên miền rơi, và từng tên miền dự kiến rơi cùng lần bắt tương ứng.',
    dropTimesNote:
      'Thời điểm rơi do chúng ta tự ghi nhận: nhân viên nhập vào hoặc lấy từ thông báo của registry. Không registry nào gửi cho chúng ta danh sách tên miền sắp rơi, nên một tên miền vẫn có thể rơi vào thời điểm không ai ghi nhận.',
    view: 'Chế độ xem',
    backorders: 'Yêu cầu đặt giữ',
    drops: 'Tên miền sắp rơi',
    status: 'Trạng thái',
    domain: 'Tên miền',
    domainPlaceholder: 'tên chính xác',
    loadBackordersError: 'Không tải được danh sách đặt giữ tên miền',
    loadDropsError: 'Không tải được danh sách tên miền sắp rơi',
    noBackorders: 'Không có yêu cầu đặt giữ nào phù hợp',
    noDrops: 'Không có tên miền sắp rơi phù hợp',
    customer: 'Khách hàng',
    level: 'Gói',
    priority: 'Thứ tự ưu tiên',
    price: 'Giá',
    auction: 'Đấu giá',
    placed: 'Đặt lúc',
    expectedDrop: 'Dự kiến rơi',
    source: 'Nguồn',
    dropCatch: 'Lần bắt tên miền',
    for: 'cho',
    registry: 'Registry',
    openBackorder: 'Mở yêu cầu đặt giữ {{domain}}',
    openDrop: 'Mở tên miền rơi {{domain}}',
  },
  backorder: {
    title: 'Yêu cầu đặt giữ tên miền',
    docTitle: 'Đặt giữ {{domain}}',
    loadError: 'Không tải được yêu cầu đặt giữ',
    request: 'Yêu cầu',
    customer: 'Khách hàng',
    registrant: 'Chủ thể đăng ký',
    registry: 'Registry',
    domain: 'Tên miền',
    level: 'Gói',
    priority: 'Hạng ưu tiên',
    queue: 'Vị trí trong hàng chờ',
    queuePosition: 'Thứ {{position}} trong {{count}} khách đang chờ tên miền này',
    price: 'Giá đã chốt',
    placed: 'Đặt lúc',
    updated: 'Thay đổi gần nhất',
    nameservers: 'Nameserver',
    agreement: 'Phiên bản điều khoản đã chấp nhận',
    statusReason: 'Lý do',
    id: 'ID',
    hold: 'Số tiền đang tạm giữ',
    holdAmount: 'Số tiền',
    holdPurpose: 'Tạm giữ cho',
    holdExpires: 'Giữ đến',
    holdClosed: 'Đã đóng',
    holdNote:
      'Khách hàng không dùng được số tiền này khi yêu cầu đặt giữ còn hiệu lực. Chỉ thu tiền nếu chúng ta bắt được tên miền.',
    drop: 'Dự kiến rơi',
    noDrop: 'Chưa ghi nhận thời điểm rơi cho tên miền này.',
    openDrop: 'Mở tên miền rơi',
    auction: 'Phiên đấu giá',
    openAuction: 'Mở phiên đấu giá',
    winner: 'Người thắng',
    finalPrice: 'Giá cuối cùng',
    bids: 'Lượt trả giá',
    noAuction: 'Yêu cầu đặt giữ này chưa từng chuyển sang đấu giá.',
    attempt: 'Lần bắt tên miền',
    window: 'Khung bắt',
    interval: 'Kiểm tra tình trạng mỗi {{ms}} ms',
    checks: 'Số lần kiểm tra đã gửi',
    lastCheck: 'Kết quả gần nhất',
    outcome: 'Kết quả',
    finished: 'Kết thúc lúc',
    noAttempt: 'Chưa lên kế hoạch bắt tên miền.',
    history: 'Lịch sử',
    historyDesc: 'Mọi thay đổi của yêu cầu đặt giữ này, cũ nhất trước',
    noHistory: 'Chưa có diễn biến nào.',
  },
  drop: {
    title: 'Tên miền sắp rơi',
    docTitle: 'Tên miền rơi {{domain}}',
    loadError: 'Không tải được tên miền rơi',
    details: 'Thông tin tên miền rơi',
    domain: 'Tên miền',
    registry: 'Registry',
    expected: 'Dự kiến rơi',
    source: 'Nguồn thời điểm rơi',
    sourceReference: 'Số tham chiếu',
    statusReason: 'Lý do',
    recorded: 'Ghi nhận lúc',
    recordedBy: 'Người ghi nhận',
    updated: 'Thay đổi gần nhất',
    id: 'ID',
    auction: 'Phiên đấu giá',
    openAuction: 'Mở phiên đấu giá',
    winner: 'Người thắng',
    finalPrice: 'Giá cuối cùng',
    bids: 'Lượt trả giá',
    noAuction: 'Tên miền này không được đưa ra đấu giá.',
    attempt: 'Lần bắt tên miền',
    attemptFor: 'Bắt cho',
    window: 'Khung bắt',
    interval: 'Kiểm tra tình trạng mỗi {{ms}} ms',
    checks: 'Số lần kiểm tra đã gửi',
    lastCheck: 'Kết quả gần nhất',
    outcome: 'Kết quả',
    amount: 'Số tiền tạm giữ',
    finished: 'Kết thúc lúc',
    noAttempt: 'Chưa lên kế hoạch bắt tên miền.',
    queue: 'Yêu cầu đặt giữ đang chờ',
    queueDesc: 'Ưu tiên cao nhất trước; yêu cầu đặt giữ đầu tiên được gán khi tên miền rơi',
    noQueue: 'Chưa có khách hàng nào đặt giữ tên miền này.',
    customer: 'Khách hàng',
    level: 'Gói',
    priority: 'Ưu tiên',
    price: 'Giá',
    status: 'Trạng thái',
    placed: 'Đặt lúc',
    open: 'Mở yêu cầu đặt giữ của {{customer}}',
  },
  bo: {
    show: 'Xem danh sách',
    loadError: 'Không tải được dữ liệu backorder',
    noGuaranteeTitle: 'Backorder không bảo đảm giành được tên miền',
    noGuarantee: 'Ngày hết hạn không phải ngày giải phóng. Mỗi thời điểm giải phóng lấy từ thông báo của registry, vòng đời tên miền hoặc do nhân viên nhập, và nhà đăng ký khác có thể đăng ký trước.',
    stage: {
      discover: 'Sắp giải phóng',
      discoverHint: 'Thời điểm đã ghi nhận',
      request: 'Yêu cầu đang chờ',
      requestHint: 'Giữ tiền theo từng yêu cầu',
      catch: 'Giành đăng ký',
      catchHint: 'Kiểm tra lúc giải phóng',
      allocate: 'Phân bổ',
      allocateHint: 'Một yêu cầu, hoặc đấu giá',
    },
    overview: {
      title: 'Trung tâm backorder',
      subtitle: 'Tên miền sắp được giải phóng, khách đang chờ, việc giành đăng ký lúc giải phóng và kết quả.',
      open: 'Backorder đang mở',
      openHint: 'Đang chờ, đã phân, đang đấu giá hoặc đang đăng ký',
      soon: 'Giải phóng trong 48 giờ',
      soonHint: 'Thời điểm dự kiến, không cam kết',
      catching: 'Đang giành đăng ký',
      catchingHint: 'Đã lên lịch, đang kiểm tra hoặc đang đăng ký',
      won: 'Đã giành được / thắng',
      wonHint: 'Đã đăng ký cho khách, hoặc thắng đấu giá',
      pipeline: 'Quy trình backorder',
      pipelineHint: 'Yêu cầu đi từ lúc có thời điểm giải phóng đến khi có kết quả. Phân bổ theo quy tắc backorder đang áp dụng.',
      rowScheduled: 'Chờ giải phóng',
      rowAssigned: 'Phân cho một yêu cầu',
      rowAuction: 'Nhiều yêu cầu → đấu giá',
      rowCaught: 'Đã giành được',
      rowNotCaught: 'Không giành được',
      ofDrops: '{{n}} / {{total}} tên miền',
      tasks: 'Công việc ưu tiên',
    },
    task: {
      soon: 'Giải phóng trong 24 giờ',
      soonHint: 'Kiểm tra thời điểm và nguồn thông tin',
      review: 'Lần giành đăng ký cần xem lại',
      reviewHint: 'Kết quả chưa rõ; không tự trừ hoặc hoàn tiền',
      auction: 'Backorder đang đấu giá',
      auctionHint: 'Nhiều khách cùng chờ một tên miền',
      notCaught: 'Không giành được',
      notCaughtHint: 'Tiền giữ chỗ đã được hoàn',
    },
    drops: {
      title: 'Tên miền sắp giải phóng',
      subtitle: 'Mọi thời điểm giải phóng dự kiến cùng nguồn và lần giành đăng ký. Thời điểm được ghi nhận, không phải dự đoán.',
      listHint: 'Thời điểm dự kiến mới nhất lên đầu.',
      dataTitle: 'Thời điểm giải phóng lấy từ đâu',
      schedule: 'Ghi nhận thời điểm giải phóng',
      scheduleTitle: 'Ghi nhận thời điểm giải phóng dự kiến',
      scheduleHint: 'Nhập thời điểm bạn có từ registry hoặc nguồn tin cậy khác. Các backorder đang chờ tên miền này được phân bổ khi gần tới thời điểm giải phóng.',
      expected: 'Thời điểm giải phóng dự kiến',
      expectedHint: 'Giờ địa phương của bạn; được lưu thành một thời điểm chính xác.',
      reference: 'Mã nguồn',
      referenceHint: 'Số thông báo của registry hoặc mã phiếu (không bắt buộc).',
      scheduled: 'Đã ghi nhận thời điểm giải phóng của {{domain}}.',
    },
    requests: {
      title: 'Yêu cầu backorder',
      subtitle: 'Từng yêu cầu của khách: gói, giá, thứ tự chờ và đấu giá.',
      statesTitle: 'Các trạng thái tách biệt',
      statesHint: 'Yêu cầu, lần giành đăng ký và khoản tiền giữ chỗ có trạng thái riêng.',
      stateRequest: 'Yêu cầu',
      stateCatch: 'Giành đăng ký',
      stateMoney: 'Tiền giữ chỗ',
    },
    catching: {
      title: 'Giành đăng ký',
      subtitle: 'Mọi lần giành đăng ký: khung thời gian, số lần kiểm tra và kết quả.',
      running: 'Đang chạy',
      runningHint: 'Đã lên lịch, đang kiểm tra hoặc đang đăng ký',
      caught: 'Đã giành được',
      caughtHint: 'Đã đăng ký cho khách',
      notCaught: 'Không giành được',
      notCaughtHint: 'Hết khung thời gian hoặc bên khác đã đăng ký',
      review: 'Cần xem lại',
      reviewHint: 'Kết quả chưa rõ',
      attempts: 'Các lần giành đăng ký',
      attemptsHint: 'Mỗi tên miền một lần, cho yêu cầu được phân tên miền.',
      none: 'Chưa có lần giành đăng ký nào.',
      result: 'Kết quả',
      openDomain: 'Mở tên miền',
      openOrder: 'Mở đơn hàng',
      registries: 'Theo registry',
      registriesHint: 'Việc giành đăng ký chạy trên phần kết nối dành riêng cho việc này của từng registry.',
      registryLine: '{{running}} đang chạy · {{caught}} giành được · {{failed}} không giành được',
      capacity: 'Số phiên và tốc độ lệnh dành cho giành đăng ký được đặt theo từng kết nối registry.',
      capacityLink: 'Mở kết nối registry',
      rulesTitle: 'Kết quả được quyết định thế nào',
      rulesHint: 'Quy tắc của tiến trình giành đăng ký.',
      rule: {
        window: 'Kiểm tra từ thời điểm giải phóng đến hết khung thời gian',
        windowHint: 'Kiểm tra tên miền còn trống nhiều lần trên phần kết nối riêng; không dùng kết nối thường.',
        register: 'Tên miền trống được đăng ký ngay',
        registerHint: 'Qua quy trình đăng ký thông thường, có kiểm tra hồ sơ và tuân thủ.',
        capture: 'Chỉ trừ tiền sau khi registry xác nhận',
        captureHint: 'Không giành được thì tiền giữ chỗ được hoàn.',
        unknown: 'Đăng ký chưa rõ kết quả thì chờ đối soát',
        unknownHint: 'Lần giành giữ trạng thái "đang đăng ký" cho tới khi biết câu trả lời của registry.',
      },
      note: 'Kết quả lấy từ registry. Tên miền biến khỏi danh sách giải phóng không có nghĩa là đã giành được.',
    },
    holds: {
      title: 'Giữ chỗ & hoàn trả',
      subtitle: 'Tiền giữ cho backorder và lượt đặt giá: khoản đang giữ, đã trừ và đã hoàn.',
      purpose: 'Giữ cho',
      purposes: { DROPCATCH: 'Backorder', AUCTION: 'Lượt đặt giá' },
      active: 'Đang giữ',
      captured: 'Đã trừ',
      released: 'Đã hoàn / hết hạn',
      capped: 'Đang hiện {{n}} khoản mới nhất; số đếm và tổng chỉ tính các khoản này.',
      listHint: 'Mới nhất lên đầu. Mở một khoản để xem bút toán.',
      loadError: 'Không tải được các khoản giữ chỗ',
      none: 'Không có khoản giữ chỗ.',
      for: 'Tên miền',
      backorder: 'Backorder',
      bid: 'Lượt đặt giá',
      amount: 'Số tiền',
      created: 'Giữ lúc',
      closed: 'Đóng lúc',
      order: 'Đơn hàng',
      rulesTitle: 'Khi nào tiền được trừ / hoàn',
      rule: {
        hold: 'Đặt backorder là giữ số tiền của gói',
        holdHint: 'Tiền giữ chỗ không phải doanh thu; số dư vẫn còn nhưng không dùng được.',
        capture: 'Trừ khi tên miền đã được đăng ký',
        captureHint: 'Chỉ sau khi registry xác nhận đăng ký.',
        release: 'Hoàn khi không giành được',
        releaseHint: 'Cũng hoàn khi yêu cầu bị huỷ hoặc thua đấu giá.',
        auction: 'Trong đấu giá riêng, lượt thắng chịu khoản trừ',
        auctionHint: 'Tiền giữ của backorder người thắng được hoàn; tiền giữ của lượt đặt giá được trừ.',
      },
    },
    detail: {
      title: 'Backorder · {{domain}}',
      subtitle: '{{customer}} · {{level}}',
      kicker: 'Backorder tên miền',
      dropLine: 'Giải phóng: {{status}} · nguồn: {{source}}',
      flow: 'Sau khi giải phóng',
      flowHint: 'Yêu cầu này đang ở bước nào.',
      summary: 'Tóm tắt',
      cancel: 'Huỷ yêu cầu',
      cancelOpen: 'Được khi còn đang chờ',
      cancelClosed: 'Không còn huỷ được',
      openHold: 'Mở khoản giữ chỗ',
      notYetTitle: 'Giành được chưa có nghĩa là đã sở hữu',
      notYet: 'Khách chỉ đứng tên khi registry xác nhận đăng ký, tiền đã trừ và hồ sơ hợp lệ.',
    },
    step: {
      placed: 'Đặt yêu cầu',
      placedHint: 'Đã giữ tiền',
      drop: 'Giải phóng',
      dropHint: 'Chưa có thời điểm',
      allocate: 'Phân bổ',
      allocateAuction: 'Nhiều yêu cầu: đấu giá',
      allocateDirect: 'Một yêu cầu: phân thẳng',
      catch: 'Giành đăng ký',
      catchHint: 'Kiểm tra và đăng ký',
      result: 'Kết quả',
      resultHint: 'Giành được hay không',
    },
  },
  au: {
    market: {
      title: 'Phiên đấu giá',
      all: 'Tất cả',
      view: 'Hiển thị',
      cards: 'Dạng thẻ',
      table: 'Dạng bảng',
      openSession: 'Mở phiên',
      reserveNotMet: 'Chưa đạt giá sàn',
      rulesTitle: 'Phiên đấu giá đến từ đâu',
      rules: 'Đấu giá công khai do nhân viên tạo. Đấu giá riêng giữa những người đặt backorder do hệ thống tạo khi nhiều khách cùng chờ một tên miền.',
    },
    detail: {
      title: 'Đấu giá · {{domain}}',
      subtitle: '{{kind}} · {{id}}',
      rules: 'quy tắc v{{version}}',
      terms: 'Quy tắc phiên đã chốt',
      policy: 'Phiên bản quy tắc',
      handover: 'Kết quả & bàn giao',
      settlement: 'Quyết toán',
    },
    flow: {
      closed: 'Đã đóng đặt giá',
      winner: 'Đã chọn người thắng',
      paid: 'Đã thu tiền',
      paidHint: 'Đã ghi bút toán',
      assigned: 'Đã bàn giao tên miền',
    },
    sessions: {
      title: 'Tạo & quản lý phiên',
      subtitle: 'Tạo phiên đấu giá công khai; mở hoặc đóng phiên khi tiến trình tự động chậm.',
      createTitle: 'Phiên đấu giá công khai mới',
      createHint: 'Quy tắc đang áp dụng được chốt vào phiên ngay khi tạo.',
      currency: 'Tiền tệ',
      amountHint: 'Số tiền nguyên theo tiền tệ, ví dụ 500000.',
      reserve: 'Giá sàn (không bắt buộc)',
      reserveHint: 'Không hiện cho người đặt giá; bỏ trống thì lượt cao nhất thắng.',
      startsHint: 'Bỏ trống: mở ngay.',
      timesInvalid: 'Thời điểm kết thúc phải sau thời điểm bắt đầu.',
      create: 'Tạo phiên đấu giá',
      created: 'Đã tạo phiên theo quy tắc v{{version}}.',
      openCreated: 'Mở phiên vừa tạo',
      noPermission: 'Vai trò của bạn không được tạo phiên đấu giá.',
      gatesTitle: 'Trước và trong phiên',
      gate: {
        rules: 'Quy tắc được chốt khi tạo',
        rulesHint: 'Bước giá, gia hạn và quyết toán theo phiên bản quy tắc lưu cùng phiên.',
        live: 'Phiên đang mở không được sửa',
        liveHint: 'Chỉ có thể đóng hoặc huỷ, mỗi thao tác kèm lý do trong nhật ký.',
        override: 'Đổi kết quả cần người thứ hai',
        overrideHint: 'Huỷ hoặc trao kết quả của phiên đã đóng phải qua phê duyệt.',
        private: 'Đấu giá riêng không tạo ở đây',
        privateHint: 'Chúng đến từ backorder khi nhiều khách cùng chờ một tên miền.',
      },
      pendingTitle: 'Phiên cần điều hành',
      pendingHint: 'Phiên đã lên lịch, đang mở và đã đóng.',
      nonePending: 'Không có phiên nào cần xử lý.',
      window: 'Bắt đầu → kết thúc',
      actions: 'Thao tác',
    },
    bids: {
      title: 'Lượt đặt giá & audit',
      subtitle: 'Mọi lượt đặt giá của {{n}} phiên gần nhất, được nhận và bị từ chối, kèm lý do.',
      sessions: 'Số phiên đã đọc',
      sessionsHint: 'Các phiên gần nhất đã mở',
      accepted: 'Lượt được nhận',
      acceptedHint: 'Mỗi lượt có số thứ tự do máy chủ cấp',
      rejected: 'Lượt bị từ chối',
      rejectedHint: 'Được lưu kèm lý do',
      overridden: 'Kết quả đã điều chỉnh',
      overriddenHint: 'Sau khi người thứ hai phê duyệt',
      list: 'Lượt đặt giá',
      listHint: 'Mới nhất lên đầu. Lượt bị từ chối không bao giờ tính vào giá.',
      none: 'Không có lượt nào khớp.',
      received: 'Nhận lúc',
      session: 'Phiên',
      reason: 'Lý do',
      valid: 'Hợp lệ',
      reasonsTitle: 'Từ chối theo lý do',
      noRejects: 'Không có lượt bị từ chối.',
      guardsTitle: 'Cơ chế đặt giá được bảo vệ thế nào',
      guard: {
        seq: 'Mỗi phiên một thứ tự đặt giá',
        seqHint: 'Máy chủ đánh số lượt được nhận; trình duyệt không quyết định thứ tự.',
        rejects: 'Lượt bị từ chối được ghi lại',
        rejectsHint: 'Muộn, thấp hơn mức tối thiểu, sai tiền tệ hoặc không đủ điều kiện.',
        funds: 'Giữ tiền cho lượt dẫn đầu',
        fundsHint: 'Lượt không đủ số dư bị từ chối.',
        override: 'Chỉ đổi kết quả khi có phê duyệt',
        overrideHint: 'Phiên có dấu hiệu bất thường do người xem xét; không tự kết luận.',
      },
    },
    settlement: {
      title: 'Quyết toán',
      subtitle: 'Các phiên đã đóng: người thắng, thanh toán và bàn giao, xem từng phiên.',
      awaiting: 'Chờ quyết toán',
      awaitingHint: 'Đã đóng, đã biết người thắng',
      settling: 'Đang quyết toán',
      settlingHint: 'Đã tạo đơn, đang thu tiền',
      settled: 'Đã quyết toán',
      settledHint: 'Đã thu tiền và bàn giao',
      failed: 'Thất bại',
      failedHint: 'Cần quyết định',
      list: 'Phiên sau khi đóng',
      listHint: 'Chọn một phiên để xem quyết toán.',
      none: 'Chưa có phiên nào đóng.',
      hasOrder: 'Đã tạo đơn',
      detailTitle: 'Quyết toán · {{domain}}',
      hold: 'Tiền giữ của người thắng',
      openHold: 'Mở khoản giữ chỗ',
      capture: 'Khoản trừ',
      openEntry: 'Mở bút toán',
      flow: 'Các bước quyết toán',
      noEvents: 'Chưa có sự kiện quyết toán.',
      openSession: 'Mở phiên',
      noEscrowTitle: 'Không có dịch vụ ký quỹ',
      noEscrow: 'Quyết toán dùng ví của khách: tiền giữ của lượt thắng được trừ, tiền giữ của người khác được hoàn. Không có chi trả cho người bán hay ký quỹ bên ngoài.',
    },
    handover: {
      title: 'Bàn giao tên miền',
      subtitle: 'Tên miền thắng đấu giá hoặc giành được qua backorder, cho tới khi vào tài khoản người nhận.',
      list: 'Tên miền đang bàn giao',
      listHint: 'Chọn một tên miền để xem các bước.',
      none: 'Chưa có tên miền nào cần bàn giao.',
      from: 'Nguồn',
      source: { auction: 'Đấu giá', backorder: 'Backorder' },
      recipient: 'Người nhận',
      amount: 'Giá',
      stageCol: 'Bước',
      stage: { won: 'Đã thắng', order: 'Đã tạo đơn', paid: 'Đã thu tiền', assigned: 'Đã vào tài khoản' },
      failed: 'Thất bại',
      flow: 'Các bước bàn giao',
      gatesTitle: 'Điều kiện',
      gate: {
        paid: 'Đã thu tiền',
        paidHint: 'Tiền giữ chỉ bị trừ sau khi registry xác nhận.',
        dossier: 'Đăng ký với hồ sơ hợp lệ',
        dossierHint: 'Việc đăng ký chạy kiểm tra hồ sơ và tuân thủ thông thường.',
        code: 'Không hiện mã chuyển tên miền',
        codeHint: 'Tên miền được đăng ký thẳng vào tài khoản người nhận.',
      },
      openDrop: 'Mở tên miền sắp giải phóng',
      noteTitle: 'Bàn giao là một lần đăng ký',
      note: 'Tên miền từ đấu giá và backorder được đăng ký cho người thắng qua quy trình đăng ký; ở đây không có chuyển giữa tài khoản hay chuyển nhà đăng ký.',
    },
  },
};
